angular.
module("dx.webapp.api").
factory("dxApiV1StudentInfo", function apiV1StudentInfoService(
	$http,
	$httpParamSerializer
) {
	"use strict";

	var path = "/api/v1/studentinfo";

	function get(query, accessibilitySettings, excludeCode, all, byEmailCode) {
		var queryParameters = {};

		queryParameters.query = query;

		if (accessibilitySettings) {
			queryParameters.accessibilitySettings = accessibilitySettings;
		}

		if (excludeCode) {
			queryParameters.excludeCode = excludeCode;
		}

		if (all) {
			queryParameters.all = all;
		}

		if (byEmailCode) {
			queryParameters.byEmailCode = byEmailCode;
		}

		return $http.get(path + "?" + $httpParamSerializer(queryParameters));
	}

	return {
		get: get,
	};
});
